import {
    Component,
    Input,
    OnInit,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    ChangeDetectorRef,
    ChangeDetectionStrategy,
} from '@angular/core';

import { AngularFireDatabase, AngularFireAction } from 'angularfire2/database';
import * as firebase from 'firebase/app';
// import 'firebase/auth';
import 'firebase/database';

import { AuthService } from '../auth/guard.service';
import { TagService } from '../tags/tag.service';

import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/combineLatest';


import { Item, IndexedSnap, SelectRequest, SelectRequestDir } from './Item.component';

import { IndexedRef } from './NewItem.component';

import { DateUtils } from '../dateutils.service';

interface DatesData {
    date : Date,
    observable : Observable<AngularFireAction<firebase.database.DataSnapshot>[]>
}

interface TagCount {
    tag: string,
    count: number,
}

@Component({
    selector: 'list-for-week',
    templateUrl: './ListForWeek.component.html',
    styleUrls: ['./ListForWeek.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListForWeekComponent implements OnInit, OnChanges, OnDestroy {

    @Input() startOfWeek : Date;

    public uid : string;
    private authSubs : Subscription;
    private combinedSubs : Subscription;

    public dates : Date[] = [];
    public datesData : DatesData[];
    public tagCounts : TagCount[] = [];

    constructor(public afDb : AngularFireDatabase, public auth : AuthService, private ch : ChangeDetectorRef, private dateutils : DateUtils, private tagService : TagService) { }

    titleForDate(date : Date) : string {
        return this.dateutils.formatDateDisplay(date);
    }

    generateDates() {
        if (!this.uid) {
            return;
        }

        if (this.dates.length > 0) {
            // already have something generated
            if (this.dateutils.isSameDate(this.dates[0], this.startOfWeek)) {
                // same week, do nothing.
                return;
            }
            this.dates.length = 0;
        }
        for (var i=0;i<7;i++) {
            let d = new Date(this.startOfWeek);
            d.setDate(d.getDate() + i);
            this.dates.push(d);
        }

        this.datesData = [];
        for (var i=0;i<this.dates.length;i++) {
            this.datesData.push({
                date: this.dates[i],
                observable: this.makeObservableForDate(this.dates[i]),
            });
        }

        let allobs = this.datesData.map((x) => x.observable);
        let o = allobs.shift();
        let combinedDays = o.combineLatest(allobs);

        if (this.combinedSubs) {
            this.combinedSubs.unsubscribe();
            this.combinedSubs = null;
        }

        this.combinedSubs = combinedDays.subscribe(data => {
            this.updateCharts(data);
        });

        this.ch.markForCheck();
    }

    updateCharts(data : [any]) {

        // count the charts here

        let tagIdx : { [tag: string]: number; }= {};

        for (var dayidx in data) {
            let day = data[dayidx];
            for (var itemidx in day) {
                let item = day[itemidx];
                let itemData = item.val();
                let tags = this.tagService.parse(itemData.text);

                for (let tag of tags) {
                    if (tagIdx[tag.normalised]) {
                        tagIdx[tag.normalised]++;
                    } else {
                        tagIdx[tag.normalised]=1;
                    }
                }
            }
        }

        let tags = Object.keys(tagIdx).sort();

        this.tagCounts = tags.map(function(t : string) : TagCount {
            return {tag: t, count: tagIdx[t]}
        });
    }

    makeObservableForDate(date : Date) {
        let path = "/items/" + this.uid + "/" + this.dateutils.formatDate(date);
        return this.afDb.list(path).snapshotChanges();
    }

    dayUrl(date : Date) {
        return this.dateutils.dayUrl(date);
    }

    ngOnInit() {
        this.authSubs = this.auth.user.subscribe(user => {
            if (user) {
                this.uid = user.uid;
                this.generateDates();
            } else {
                this.dates = [];
                this.datesData = [];
                // if (this.itemsSubs) {
                //     this.itemsSubs.unsubscribe();
                //     this.itemsSubs = null;
                // }
            }
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        this.generateDates();
    }

    ngOnDestroy() {
        if (this.authSubs) {
            this.authSubs.unsubscribe();
            this.authSubs = null;
        }
        if (this.combinedSubs) {
            this.combinedSubs.unsubscribe();
            this.combinedSubs = null;
        }
    }
}



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/items/ListForWeek.component.ts